import {ApplicationStoreType} from 'reducers';

/**
 * Get flag "is visible" of menu
 * @param {ApplicationStoreType} store - Application store
 * @returns {boolean} Flag "is visible"
 */
export const isVisible = (store: ApplicationStoreType): boolean => store.visibilityMenu.visible;
